<app-header></app-header>

<router-outlet />

<app-footer></app-footer>